import { memo, useContext } from 'react';
import styled from '@emotion/styled';
import useDateDisplayWithFormat from '../../../lib/useDateDisplayWithFormat';
import useThemeStyles from '../../../lib/useThemeStyles';
import zIndices from '../../../lib/zIndices';
import { WWContext, type WWContextValue } from '../../WWContext';
import { isWwsWeddingWebsiteV2 } from '../../../types/graphql';
import SiteTitle from './SiteTitle';
import { SiteSubtitleWithDateLocation } from './SiteSubtitle';
import InitialsFlourish from './InitialsFlourish';
import InlineEditHandler from '../../InlineEdit/InlineEditHandler/InlineEditHandler';
import { buildEditDateLocationContextMenuButtons } from '../../InlineEdit/InlineEditMessageFactory';
import { getCoupleNames } from '../../../lib/getCoupleNames';

const HeaderWrap = styled('header')`
  padding: 0 4% 10px 4%;
  text-align: center;
  width: 100%;
  z-index: ${zIndices.header};
`;

export interface HeaderProps {
  heroVersion: boolean;
  className?: string | undefined;
}

function Header({ className, heroVersion }: HeaderProps) {
  const { data } = useContext<WWContextValue>(WWContext);

  const formattedDate = useDateDisplayWithFormat();

  const themeStyles = useThemeStyles();

  if (isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
    const { countdownDays } = data.weddingWebsiteResult;
    const [primaryName, secondaryName] =
      getCoupleNames({ weddingWebsiteResult: data?.weddingWebsiteResult }) ??
      [];

    return (
      <HeaderWrap className={className}>
        <>
          {themeStyles.config?.displayInitialsLockup && (
            <InitialsFlourish
              firstName={primaryName}
              fianceFirstName={secondaryName}
              themeId={data.weddingWebsiteResult.theme?.id}
            />
          )}

          <SiteTitle
            weddingWebsiteResult={data?.weddingWebsiteResult}
            heroVersion={heroVersion}
          />

          <InlineEditHandler
            contextMenuButtons={buildEditDateLocationContextMenuButtons()}
          >
            <SiteSubtitleWithDateLocation
              data-testid="header-wedding-date-location"
              heroVersion={heroVersion}
              weddingDate={formattedDate}
              weddingLocation={data?.weddingWebsiteResult?.weddingLocation}
              countdownDays={countdownDays}
            />
          </InlineEditHandler>
        </>
      </HeaderWrap>
    );
  }

  return null;
}

export default memo(Header);
